module.exports = __webpack_public_path__ + "static/media/centaur.d4e28370.png";